module.exports = __webpack_public_path__ + "static/media/tourism-boards-9.c2595302.jpg";